// Physical constants of the simulation (spec §7). Every module reads them from here.
export const RHO_AIR = 1.225;
export const RHO_WATER = 1025;
export const NU_WATER = 1.19e-6;
export const G = 9.81;
